const state = {
   isUnauthenticated: false,
   isLoaderActive: null,
   loaderText: null,
}

export default state;